/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BulkOperationsRequestBody,
    BulkOperationsRequestBodyFromJSON,
    BulkOperationsRequestBodyToJSON,
    Flag,
    FlagFromJSON,
    FlagToJSON,
    FlagMap,
    FlagMapFromJSON,
    FlagMapToJSON,
    FlagRequestBody,
    FlagRequestBodyFromJSON,
    FlagRequestBodyToJSON,
    Flags,
    FlagsFromJSON,
    FlagsToJSON,
    PatchRequestBody,
    PatchRequestBodyFromJSON,
    PatchRequestBodyToJSON,
    ProblemDetail,
    ProblemDetailFromJSON,
    ProblemDetailToJSON,
} from '../models';

export interface ArchiveFlagsRequest {
    project_id: number;
    bulk_operations_request_body: BulkOperationsRequestBody;
}

export interface CreateFlagRequest {
    project_id: number;
    flag_request_body: FlagRequestBody;
}

export interface DeleteFlagRequest {
    project_id: number;
    flag_key: string;
}

export interface FetchFlagRequest {
    project_id: number;
    flag_key: string;
}

export interface ListFlagsRequest {
    project_id: number;
    per_page?: number;
    page_number?: number;
    page_token?: string;
    page_window?: number;
    sort?: Array<ListFlagsSortEnum>;
    archived?: boolean;
    enabled?: boolean;
    rule_status?: Array<string>;
    environment_status?: Array<string>;
    environment_type?: Array<string>;
    environment?: Array<string>;
    rule_type?: Array<string>;
    query?: string;
    key_list?: Array<string>;
}

export interface UnarchiveFlagsRequest {
    project_id: number;
    bulk_operations_request_body: BulkOperationsRequestBody;
}

export interface UpdateFlagsRequest {
    project_id: number;
    patch_request_body: Array<PatchRequestBody>;
}

/**
 * no description
 */
export class FlagsApi extends runtime.BaseAPI {

    /**
     * Archive one or more Flags in a project.  This operation corresponds to the `archive_url` in a Flags response. 
     * Archive Flags
     */
    async archiveFlagsRaw(requestParameters: ArchiveFlagsRequest): Promise<runtime.ApiResponse<FlagMap>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling archiveFlags.');
        }

        if (requestParameters.bulk_operations_request_body === null || requestParameters.bulk_operations_request_body === undefined) {
            throw new runtime.RequiredError('bulk_operations_request_body','Required parameter requestParameters.bulk_operations_request_body was null or undefined when calling archiveFlags.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/flags/archived`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkOperationsRequestBodyToJSON(requestParameters.bulk_operations_request_body),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FlagMapFromJSON(jsonValue));
    }

    /**
     * Archive one or more Flags in a project.  This operation corresponds to the `archive_url` in a Flags response. 
     * Archive Flags
     */
    async archiveFlags(requestParameters: ArchiveFlagsRequest): Promise<FlagMap> {
        const response = await this.archiveFlagsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates a new Flag in a Project.  This operation corresponds to the `create_url` in a Flags response.  Required properties must be present in the request body. 
     * Create a New Flag
     */
    async createFlagRaw(requestParameters: CreateFlagRequest): Promise<runtime.ApiResponse<Flag>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling createFlag.');
        }

        if (requestParameters.flag_request_body === null || requestParameters.flag_request_body === undefined) {
            throw new runtime.RequiredError('flag_request_body','Required parameter requestParameters.flag_request_body was null or undefined when calling createFlag.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/flags`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FlagRequestBodyToJSON(requestParameters.flag_request_body),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FlagFromJSON(jsonValue));
    }

    /**
     * Creates a new Flag in a Project.  This operation corresponds to the `create_url` in a Flags response.  Required properties must be present in the request body. 
     * Create a New Flag
     */
    async createFlag(requestParameters: CreateFlagRequest): Promise<Flag> {
        const response = await this.createFlagRaw(requestParameters);
        return await response.value();
    }

    /**
     * Permanently delete a Flag by key.  There will be no way to access this data after deletion. If you want to stop seeing a Flag without deleting it permanently, try archiving instead. 
     * Delete a Flag
     */
    async deleteFlagRaw(requestParameters: DeleteFlagRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling deleteFlag.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling deleteFlag.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permanently delete a Flag by key.  There will be no way to access this data after deletion. If you want to stop seeing a Flag without deleting it permanently, try archiving instead. 
     * Delete a Flag
     */
    async deleteFlag(requestParameters: DeleteFlagRequest): Promise<void> {
        await this.deleteFlagRaw(requestParameters);
    }

    /**
     * Fetch a single Flag in a Project by its key.  This operation corresponds to the `fetch_flag_url` in a Flags response. 
     * Fetch a Single Flag
     */
    async fetchFlagRaw(requestParameters: FetchFlagRequest): Promise<runtime.ApiResponse<Flag>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling fetchFlag.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling fetchFlag.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FlagFromJSON(jsonValue));
    }

    /**
     * Fetch a single Flag in a Project by its key.  This operation corresponds to the `fetch_flag_url` in a Flags response. 
     * Fetch a Single Flag
     */
    async fetchFlag(requestParameters: FetchFlagRequest): Promise<Flag> {
        const response = await this.fetchFlagRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a list of Flags within a Project  You can use query parameters to filter/sort the response. 
     * List Flags
     */
    async listFlagsRaw(requestParameters: ListFlagsRequest): Promise<runtime.ApiResponse<Flags>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling listFlags.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.per_page !== undefined) {
            queryParameters['per_page'] = requestParameters.per_page;
        }

        if (requestParameters.page_number !== undefined) {
            queryParameters['page_number'] = requestParameters.page_number;
        }

        if (requestParameters.page_token !== undefined) {
            queryParameters['page_token'] = requestParameters.page_token;
        }

        if (requestParameters.page_window !== undefined) {
            queryParameters['page_window'] = requestParameters.page_window;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.archived !== undefined) {
            queryParameters['archived'] = requestParameters.archived;
        }

        if (requestParameters.enabled !== undefined) {
            queryParameters['enabled'] = requestParameters.enabled;
        }

        if (requestParameters.rule_status) {
            queryParameters['rule_status'] = requestParameters.rule_status;
        }

        if (requestParameters.environment_status) {
            queryParameters['environment_status'] = requestParameters.environment_status;
        }

        if (requestParameters.environment_type) {
            queryParameters['environment_type'] = requestParameters.environment_type;
        }

        if (requestParameters.environment) {
            queryParameters['environment'] = requestParameters.environment;
        }

        if (requestParameters.rule_type) {
            queryParameters['rule_type'] = requestParameters.rule_type;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.key_list) {
            queryParameters['key_list'] = requestParameters.key_list;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FlagsFromJSON(jsonValue));
    }

    /**
     * Get a list of Flags within a Project  You can use query parameters to filter/sort the response. 
     * List Flags
     */
    async listFlags(requestParameters: ListFlagsRequest): Promise<Flags> {
        const response = await this.listFlagsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Unarchive one or more Flags in a project.  This operation corresponds to the `unarchive_url` in a Flags response. 
     * Unarchive Flags
     */
    async unarchiveFlagsRaw(requestParameters: UnarchiveFlagsRequest): Promise<runtime.ApiResponse<FlagMap>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling unarchiveFlags.');
        }

        if (requestParameters.bulk_operations_request_body === null || requestParameters.bulk_operations_request_body === undefined) {
            throw new runtime.RequiredError('bulk_operations_request_body','Required parameter requestParameters.bulk_operations_request_body was null or undefined when calling unarchiveFlags.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/flags/unarchived`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkOperationsRequestBodyToJSON(requestParameters.bulk_operations_request_body),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FlagMapFromJSON(jsonValue));
    }

    /**
     * Unarchive one or more Flags in a project.  This operation corresponds to the `unarchive_url` in a Flags response. 
     * Unarchive Flags
     */
    async unarchiveFlags(requestParameters: UnarchiveFlagsRequest): Promise<FlagMap> {
        const response = await this.unarchiveFlagsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update one or more Flags in a project using a json patch structure.  Properties that are readOnly that are present in the request body will be ignored as well as unknown properties. 
     * Update Flags
     */
    async updateFlagsRaw(requestParameters: UpdateFlagsRequest): Promise<runtime.ApiResponse<FlagMap>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling updateFlags.');
        }

        if (requestParameters.patch_request_body === null || requestParameters.patch_request_body === undefined) {
            throw new runtime.RequiredError('patch_request_body','Required parameter requestParameters.patch_request_body was null or undefined when calling updateFlags.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/projects/{project_id}/flags`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patch_request_body.map(PatchRequestBodyToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FlagMapFromJSON(jsonValue));
    }

    /**
     * Update one or more Flags in a project using a json patch structure.  Properties that are readOnly that are present in the request body will be ignored as well as unknown properties. 
     * Update Flags
     */
    async updateFlags(requestParameters: UpdateFlagsRequest): Promise<FlagMap> {
        const response = await this.updateFlagsRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListFlagsSortEnum {
    Nameasc = 'name:asc',
    Namedesc = 'name:desc',
    Keyasc = 'key:asc',
    Keydesc = 'key:desc',
    CreatedTimeasc = 'created_time:asc',
    CreatedTimedesc = 'created_time:desc',
    UpdatedTimeasc = 'updated_time:asc',
    UpdatedTimedesc = 'updated_time:desc',
    EnabledInEnvironmentasc = 'enabled_in_environment:asc',
    EnabledInEnvironmentdesc = 'enabled_in_environment:desc',
    RulesInEnvironmentasc = 'rules_in_environment:asc',
    RulesInEnvironmentdesc = 'rules_in_environment:desc',
    CreatedByUserEmailasc = 'created_by_user_email:asc',
    CreatedByUserEmaildesc = 'created_by_user_email:desc'
}
